import React, { PropTypes } from 'react';

import { NitroIcon } from 'nitro-components';

import styled from 'styled-components';

const List = styled.ul`
  margin: 0 0 0 10px;
  padding: 0;
  list-style: none;
  color: ${props => props.theme.color.base2};
`;

const ListItem = styled.li`
  display: flex;
`;

const ListIcon = styled.div`
  padding: 2px 16px 0 0;
`;
const ListContent = styled.div`
  line-height: 30px;
`;

const FeatureList = ({ list }) => {
  const lists = list.map((item, index) => {
    return (
      item &&
      <ListItem key={index}>
        <ListIcon>
          <NitroIcon name="success-circle" size={16} variant="primary" />
        </ListIcon>
        <ListContent>{item}</ListContent>
      </ListItem>
    );
  });

  return (
    <List>
      {lists}
    </List>
  );
};

FeatureList.propTypes = {
  list: PropTypes.array
};

export default FeatureList;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/components/accordions/FeatureList.js